import React from "react";
import { FormControl, FormHelperText, TextField } from "@mui/material";
import { onKeyPress } from "../../../utils/forms/utils";

const JobTitle = ({ field, setValue, setError, handleSubmit, handleCancel }) => {
    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const handleError = () => {
        const currentError = field.validation
            .map((check) => check(field.value))
            .find((error) => error);
        if (currentError) {
            setError(currentError);
            return currentError;
        }
        return setError(null);
    };

    const handleBlur = () => {
        handleError();
    };

    return (
        <FormControl error={!!field.error} fullWidth>
            <TextField
                onKeyDown={onKeyPress(() => {
                    const e = handleError();
                    if (!e) handleSubmit();
                }, handleCancel)}
                label="Position"
                value={field.value}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <FormHelperText error>{field.error || " "}</FormHelperText>
        </FormControl>
    );
};

export default JobTitle;
